var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMarine4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322 242",
    style: {
      enableBackground: "new 0 0 322 242"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#1184A2;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#1184A2;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;stroke:#1184A2;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#1184A2;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#11819F;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-221.9,65.1c1.7-0.7,3.3-1.4,5-2c0.8-0.3,1.6-0.7,2.5-1l2.6-0.8c6.7-2.3,13.8-3.1,20.4-3.6 c6.8-0.1,13.1,0.4,19.3,1.6c6,1.2,11.6,2.9,16.5,5c4.9,2.1,9,4.5,12.4,7s6,4.9,8,7.2c2.1,2.3,3.6,4.2,4.6,5.5c0,0,0,0.1,0.1,0.1 l-7.9,5.4l21.7,4.1l4.1-21.7l-7.9,5.4c-0.2-0.3-0.4-0.5-0.7-0.9c-1.2-1.4-3-3.5-5.6-6c-2.5-2.5-5.9-5.5-10.1-8.2 c-4.2-2.8-9.2-5.3-14.9-7.4c-5.7-2.1-11.9-3.7-18.7-4.7c-0.9-0.1-1.7-0.2-2.5-0.3l-1.2-0.2c-0.5-0.1-0.9-0.1-1.4-0.1 c-1.8-0.1-3.5-0.2-5.3-0.3c-0.9,0-1.8-0.1-2.7-0.1s-1.8,0.1-2.7,0.1c-1.8,0.1-3.7,0.2-5.5,0.2c-7.4,0.9-15,2.2-22.2,5l-2.7,1 c-0.9,0.3-1.8,0.8-2.7,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-263.4,100.3c-0.8,1.6-1.3,3.4-2,5c-0.3,0.8-0.6,1.7-0.9,2.5l-0.5,1.2l-0.3,1.3c-0.4,1.7-0.9,3.4-1.3,5 c-0.2,0.8-0.5,1.6-0.6,2.5c-0.1,0.8-0.3,1.6-0.4,2.4c-0.3,1.6-0.5,3.2-0.8,4.7c-0.3,1.7-0.3,3.2-0.5,4.7c-0.2,3.1-0.2,6.1-0.1,8.9 c0.5,11.5,3.2,20.7,5.6,26.9c1.2,3.1,2.3,5.4,3.1,7c0.8,1.6,1.2,2.4,1.2,2.4s-0.4-0.9-1.1-2.5s-1.7-4-2.7-7.1 c-2.1-6.2-4.3-15.5-4.2-26.7c0-2.8,0.2-5.7,0.5-8.7c0.2-1.5,0.4-3.1,0.7-4.5c0.3-1.5,0.7-3.1,1-4.7c0.2-0.8,0.3-1.6,0.5-2.4 c0.2-0.8,0.5-1.5,0.7-2.3c0.5-1.5,1-3.1,1.5-4.7l0.4-1.2l0.5-1.2c0.3-0.8,0.7-1.6,1-2.3c0.7-1.5,1.3-3.2,2.1-4.7 c1.7-3,3.2-6.2,5.4-9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-48.7,87.1c-10.1-1.2-19.8-8.8-23.8-12.3c-1.1-1-2.8-1-4,0c-4.1,3.5-13.8,11.1-23.8,12.3 c-1.6,0.2-2.8,1.6-2.7,3.2c1.2,30.7,21.4,44.1,27.1,47.3c0.9,0.5,2,0.5,3,0c5.7-3.2,25.8-16.6,27.1-47.3 C-45.9,88.6-47.1,87.3-48.7,87.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -167.1891 15.4928)",
    className: "st0",
    cx: -74.5,
    cy: 106,
    rx: 14.7,
    ry: 14.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-67.8,98.3 -76.9,107.4 -81.3,102.9 -84.4,106.1 -80,110.5 -76.8,113.7 -73.7,110.5 -64.6,101.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-120.7,182.9c6.3-0.4,8.3-5.5,8.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-112.1,177.4c0,0,2.7,5.9,9,5.5s8.3-5.5,8.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-94.5,177.4c0,0,2.7,5.9,9,5.5s8.3-5.5,8.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-76.9,177.4c0,0,2.7,5.9,9,5.5c2.5-0.1,4.4-1,5.6-2.1"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-121.2,157.2 -112.4,157.2 -109.1,167.2 -83.8,167.2 -80.9,157.2 -59.9,157.2 -66.1,175.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-121.2,154.2 -121.2,147.2 -91.2,147.2 -91.2,164.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -98.2,
    y1: 157.2,
    x2: -106.2,
    y2: 157.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -98.2,
    y1: 151.2,
    x2: -102.2,
    y2: 151.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -118.2,
    y: 141.2,
    className: "st1",
    width: 3,
    height: 4
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -139.2,
    y1: 197.2,
    x2: -58.2,
    y2: 197.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -261.2,
    y1: 197.2,
    x2: -241.2,
    y2: 197.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -205.2,
    y1: 197.2,
    x2: -168.2,
    y2: 197.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-122.2,162.3v20.5c0,3.8-5.5,8.4-9.3,8.4h-11.7c-1.6-6-5.4-6.5-9.8-6.5s-8.2,0.5-9.8,6.5h-6.3v-50.6 c0-3.5,2.6-7.4,6.2-7.4h12.5c5.7,0,12.3,3.6,15.2,8.5L-122.2,162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-156.1,167.8h-2.7c-0.5,0-0.9-0.4-0.9-0.9v-10.5c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v10.5 C-155.3,167.4-155.6,167.8-156.1,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-169.2,180.2v11h-46.9c-1.6-6-5.4-6.5-9.8-6.5c-4.4,0-8.2,0.5-9.8,6.5h-15.5v-11H-169.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -237.5,
    y: 151.4,
    className: "st1",
    width: 26.5,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -226.9,
    y: 151.4,
    className: "st1",
    width: 5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -207.5,
    y: 151.4,
    className: "st1",
    width: 26.5,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -196.9,
    y: 151.4,
    className: "st1",
    width: 5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -222.6,
    y: 128.2,
    className: "st1",
    width: 26.5,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -212,
    y: 128.2,
    className: "st1",
    width: 5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-152.2,133.2 -152.2,164.2 -124.2,164.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-124.7,179.4h-5c-1.3,0-2.4-1.1-2.4-2.4l0,0c0-1.3,1.1-2.4,2.4-2.4h5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-227.1,70.5c-4-0.4-8.9-0.5-15,0.1l-5.1-21.4c-0.1-0.3,0-0.5,0.2-0.7s0.4-0.2,0.7-0.2l9.6,2.7 c0.2,0.1,0.3,0.2,0.4,0.4L-227.1,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-227.8,86.1l-10.8,18.2c-0.1,0.2-0.3,0.3-0.5,0.3l-9.8,1.8c-0.2,0.1-0.5,0-0.6-0.2 c-0.2-0.2-0.2-0.5-0.1-0.7l7-20.9C-236.7,85.8-231.8,86.2-227.8,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-268.8,91.8C-268.8,91.7-268.8,91.7-268.8,91.8c-0.2-0.3-0.2-0.5-0.2-0.7l2.8-8.7c1.2-3.7,1.4-7.7,0.5-11.6 l-2-8.9c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.4-0.3,0.6-0.2l5.9,0.3c0.3,0,0.5,0.2,0.6,0.4l4.5,10.9c23.8-4.7,35.3-1.8,40.9,1.5 c1.8,1,2.8,2.9,2.7,4.9c-0.1,2-1.2,3.8-3.1,4.6c-5.8,2.8-17.6,4.6-40.8-2.2l-5.5,10.4c-0.1,0.2-0.4,0.4-0.7,0.4l-5.8-0.3 C-268.5,92-268.7,91.9-268.8,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-223.4,77.8c-0.1-0.1-0.2-0.3-0.1-0.4l0.1-2.6c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.1,0.4-0.1 c1.4,0.1,3.8,1,3.9,1c0.2,0.1,0.4,0.3,0.4,0.6l-0.1,1.7c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.1L-223,78 C-223.2,78-223.3,77.9-223.4,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-223.6,82.4c-0.1-0.1-0.2-0.3-0.1-0.4l0.1-2.6c0-0.3,0.3-0.6,0.6-0.5l3.8,0.2c0.3,0,0.6,0.3,0.5,0.6 l-0.1,1.7c0,0.2-0.2,0.5-0.4,0.5c-0.1,0-2.6,0.7-4,0.7C-223.4,82.6-223.5,82.6-223.6,82.4C-223.6,82.5-223.6,82.4-223.6,82.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-218.9,193.7c0,3.9-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1 C-222,186.6-218.9,189.8-218.9,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.6,193.7c0,3.9-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1 C-148.7,186.6-145.6,189.8-145.6,193.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-484.3,188c3.7,3.7,9.6,7.4,17.9,7c16.2-0.9,21.3-14,21.3-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-444.5,181c0,0,6.9,14.9,23.1,14c16.2-0.9,21.3-14,21.3-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-399.6,181c0,0,6.9,14.9,23.1,14c16.2-0.9,21.3-14,21.3-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-354.6,181c0,0,6.9,14.9,23.1,14c6.4-0.4,11.1-2.6,14.4-5.3"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "-468.5,175.6 -484.3,130.1 -445.1,130.1 -436.8,150.4 -372.3,150.4 -364.9,130.1 -311.2,130.1  -328.4,176.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "-467.1,127.4 -467.1,101.2 -403,101.2 -403,146.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -404.6,
    y1: 130.1,
    x2: -423.8,
    y2: 130.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -404.6,
    y1: 116.2,
    x2: -414.2,
    y2: 116.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -461.8,
    y: 86.3,
    className: "st3",
    width: 13.9,
    height: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-319.7,58.6c-9.5-1.2-18.6-8.3-22.4-11.6c-1.1-0.9-2.7-0.9-3.7,0c-3.8,3.3-12.9,10.4-22.4,11.6 c-1.5,0.2-2.6,1.5-2.6,3c1.2,28.8,20.1,41.5,25.5,44.5c0.9,0.5,1.9,0.5,2.8,0c5.3-3,24.3-15.6,25.5-44.5 C-317.1,60.1-318.2,58.8-319.7,58.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -354.7,
    y1: 76.4,
    x2: -333.2,
    y2: 76.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -344,
    y1: 65.6,
    x2: -344,
    y2: 87.1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M534.3,110.8l-0.2,1.8c-0.4,3.6-1.6,7.1-3.7,10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M528.4,94.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M530.1,84.3l11.2-11.2c2.4-2.4,6.3-2.4,8.7,0l0,0c2.4,2.4,2.4,6.3,0,8.7l-8.8,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M541.3,90.4L552,79.7c2.4-2.4,6.3-2.4,8.7,0l0,0c2.4,2.4,2.4,6.3,0,8.7l-18.2,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M545.7,112L545.7,112c-2.4-2.4-2.4-6.3,0-8.7l12.8-12.8c2.4-2.4,6.3-2.4,8.7,0l0,0c2.4,2.4,2.4,6.3,0,8.7 L554.4,112C552,114.3,548.1,114.3,545.7,112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M552.3,122.7L552.3,122.7c-2.4-2.4-2.4-6.3,0-8.7l13.3-13.3c2.4-2.4,6.3-2.4,8.7,0h0c2.4,2.4,2.4,6.3,0,8.7 L561,122.7C558.6,125.1,554.7,125.1,552.3,122.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M513.7,93.8c0-5.1,4.2-9.3,9.3-9.3l9-0.3c5.1,0,9.3,4.2,9.3,9.3v17.2l-4.2,0c-4.6,0-8.3-3.7-8.3-8.3v-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M520.4,149.3l13.1-13.1l0,0c5.1,2.3,11.1,1.2,15-2.7l8.1-8.1"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M534.3,60.6c12.7,3.7,18.9,1,25.8-10.7c6.9,11.6,13.1,14.4,25.8,10.7c-3.7,12.7-1,18.9,10.7,25.8 c-11.6,6.9-14.4,13.1-10.7,25.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M517.2,103.4c-11.7-1.5-23-10.2-27.8-14.3c-1.3-1.2-3.3-1.2-4.6,0c-4.7,4.1-16,12.9-27.8,14.3 c-1.9,0.2-3.3,1.8-3.2,3.7c1.4,35.7,24.9,51.3,31.5,55.1c1.1,0.6,2.4,0.6,3.4,0c6.6-3.7,30.1-19.4,31.5-55.1 C520.4,105.2,519,103.6,517.2,103.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 473.8,
    y1: 125.4,
    x2: 500.4,
    y2: 125.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 487.1,
    y1: 112.1,
    x2: 487.1,
    y2: 138.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 541.1,
    y1: 144.4,
    x2: 583.8,
    y2: 144.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 562.4,
    y1: 144.4,
    x2: 562.4,
    y2: 190.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 548.5,
    y1: 190.1,
    x2: 576.4,
    y2: 190.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M583.8,170.5L583.8,170.5c-4.3,0-8.2-2.4-10.1-6.3l-1.9-3.8h24l-1.9,3.8C592,168.1,588.1,170.5,583.8,170.5z "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "575.3,159.3 583.8,144.4 592.3,159.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M541.1,170.5L541.1,170.5c-4.3,0-8.2-2.4-10.1-6.3l-1.9-3.8h24l-1.9,3.8 C549.3,168.1,545.4,170.5,541.1,170.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "532.5,159.3 541.1,144.4 549.6,159.3  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "93.9,124.4 93.9,89 163.2,60.9 235.9,89 235.9,174.3 108.3,174.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "61.3,89.9 165.1,47.3 265,89.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 96.5,
    className: "st3",
    width: 94.7,
    height: 77.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 116.5,
    y1: 130.8,
    x2: 211.2,
    y2: 130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 132.8,
    y1: 107.4,
    x2: 193.6,
    y2: 107.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 132.8,
    y1: 117.6,
    x2: 193.6,
    y2: 117.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.7,
    y: 156.3,
    className: "st3",
    width: 25.8,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.3,
    y: 156.3,
    className: "st3",
    width: 25.8,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 138.3,
    className: "st3",
    width: 25.8,
    height: 18
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.9,138.8c-9.3-1.2-18.3-8.2-22.1-11.4c-1.1-0.9-2.6-0.9-3.7,0c-3.8,3.3-12.7,10.3-22.1,11.4 c-1.5,0.2-2.6,1.4-2.5,2.9c1.2,28.4,19.8,40.9,25.1,43.8c0.9,0.5,1.9,0.5,2.7,0c5.3-3,23.9-15.4,25.1-43.8 C107.5,140.3,106.4,139,104.9,138.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 70.4,
    y1: 156.3,
    x2: 91.6,
    y2: 156.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 81,
    y1: 145.7,
    x2: 81,
    y2: 166.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarine4);
export default __webpack_public_path__ + "static/media/logo-marine-4.f0e888057f0e12304f5d2a25634a9445.svg";
export { ForwardRef as ReactComponent };